import { useEffect, useRef, useState } from 'react';

export function useAnimationLoop(phases, resetDelay = 1800) {
  const [phase, setPhase] = useState(0);
  const phasesRef = useRef(phases);
  phasesRef.current = phases;

  useEffect(() => {
    let cancelled = false;
    let timerId = null;

    const wait = (ms) =>
      new Promise((resolve) => {
        timerId = setTimeout(resolve, ms);
      });

    const run = async () => {
      const steps = phasesRef.current;
      while (!cancelled) {
        for (let i = 0; i < steps.length; i += 1) {
          if (cancelled) return;
          setPhase(i);
          await wait(steps[i]);
        }
        if (cancelled) return;
        await wait(resetDelay);
      }
    };

    run();

    return () => {
      cancelled = true;
      if (timerId) clearTimeout(timerId);
    };
  }, [resetDelay]);

  return phase;
}

export function useTypewriter(text, active, charMs = 38) {
  const [display, setDisplay] = useState('');

  useEffect(() => {
    if (!active) {
      setDisplay('');
      return undefined;
    }

    let index = 0;
    let timerId = null;
    let cancelled = false;

    const tick = () => {
      if (cancelled) return;
      index += 1;
      setDisplay(text.slice(0, index));
      if (index < text.length) {
        timerId = setTimeout(tick, charMs);
      }
    };

    tick();

    return () => {
      cancelled = true;
      if (timerId) clearTimeout(timerId);
    };
  }, [active, text, charMs]);

  return display;
}
